export default __webpack_public_path__ + "static/cv-c6419634e6fe5c8a1a5c582f2eecd7f8.pdf";